export const SLICING_HISTORY_LIST_REQUEST = "SLICING_HISTORY_LIST_REQUEST";
export const SLICING_HISTORY_LIST_SUCCESS = "SLICING_HISTORY_LIST_SUCCESS";
export const SLICING_HISTORY_LIST_FAILED = "SLICING_HISTORY_LIST_FAILED";
